import { HighlightIcon, MemberPlusIcon, HeartIcon, ZoomIcon } from "assets/icons/badges";

function getBadgeStatuses(space) {
  // Define priorities for each type with their corresponding badge URLs
  const priorities = {
    zoom: { url: "" },
    favorite: { url: "" },
    highlight: { url: ""},
    color: { url: "" }, // Replace with actual URL if available
    // photo: { url: "photoBadgeUrl" },
    // color: { url: "colorBadgeUrl" },
  };

  function hasOptionType(space, targetType) {
    const optionTypes = new Set(space.options?.map(option => option.type));
    const optionTypesWithOtherStructure = new Set(space.options?.map(option => option.option.type));
    const packTypes = new Set(
      space.packs?.flatMap(pack => pack.pack.options.map(option => option.type))
    );
    const packUserTypes = new Set(space.pack_user_options?.map(option => option.type));

    return (
      optionTypes.has(targetType) || 
      optionTypesWithOtherStructure.has(targetType) || 
      packTypes.has(targetType) || 
      packUserTypes.has(targetType)
    );
  }

  // Build the output object with only types that exist
  const result = {};
  for (const [type, { url }] of Object.entries(priorities)) {
    if (hasOptionType(space, type)) {
      result[type] = { exists: true, badgeUrl: url };
    }
  }

  // Check for additional statuses
  // if (space.partner) {
  //   result.partner = { exists: true, badgeUrl: MemberPlusIcon };
  // }
  if (space.last_minute) {
    result.last_minute = { exists: true, badgeUrl: "" };  // Replace with actual URL if available
  }

  return result;
}

export default getBadgeStatuses;

  
